var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "search_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.333 10.667c-1.21 0-2.236-.42-3.075-1.259S2 7.544 2 6.333c0-1.21.42-2.236 1.258-3.075C4.098 2.42 5.122 2 6.333 2s2.236.42 3.075 1.258c.84.84 1.259 1.864 1.259 3.075A4.062 4.062 0 0 1 9.8 8.867l3.733 3.733a.632.632 0 0 1 .184.467.632.632 0 0 1-.184.466.632.632 0 0 1-.466.184.632.632 0 0 1-.467-.184L8.867 9.8a4.062 4.062 0 0 1-2.533.867Zm0-1.334c.834 0 1.542-.291 2.125-.875a2.893 2.893 0 0 0 .875-2.125c0-.833-.291-1.541-.875-2.125a2.893 2.893 0 0 0-2.125-.875c-.833 0-1.541.292-2.125.875a2.893 2.893 0 0 0-.875 2.125c0 .834.292 1.542.875 2.125a2.893 2.893 0 0 0 2.125.875Z"
}))));
export default SvgSearch;